<template>
    <div class="container-fluid bg-white rounded-4">
        <div class="row">
            <div class="col-md-12 m-auto mt-2">
                <!--        <div class="card">-->
                <b-form-group
                        v-slot="{ ariaDescribedby }"
                        label-for="radios-btn-default"
                        class="text-center">
                    <b-form-radio-group
                            class="text-center rounded m-auto mt-3"
                            id="btn-radios-1"
                            v-model="nominee"
                            :options="nomineeOptions"
                            :aria-describedby="ariaDescribedby"
                            :button-variant="(nominee=='1')?'outline-info':'outline-success'"
                            name="nominee*"
                            buttons
                    ></b-form-radio-group>
                </b-form-group>
                <!--        </div>-->
            </div>
            <div class="your-nominee" v-if="nominee == 1">
                <div class="col-md-10 m-auto mt-3 nominee1 rounded" v-for="(itemData, index) in nomineeData"
                     :key="index">
                    <div class="card mb-2">
                        <div>
<!--                            <img v-if="nomineeImageUrlData && !nomineeImageUrlData.endsWith('/null')"-->
                            <img v-if="validImage(nomineeImageUrlData[index])"
                                 :src="nomineeImageUrlData"
                                 class="rounded-circle border-primary me-3"
                                 height="50"
                                 width="50">

                            <img v-else
                                 src="@/assets/images/profile.jpg"
                                 alt=""
                                 class="rounded-circle border-primary me-3"
                                 height="50"
                                 width="50">
                            <span style="color: gray">{{ itemData.name }}</span>
                        </div>
                        <div class="details text-secondary" style="cursor: pointer">
                            <font-awesome-icon icon="eye" style="margin-left: 60px; gap: 20px; "
                                               class="text-secondary"/>
                            <span @click="openModal(itemData)">{{$t("View Details")}}</span>
                        </div>
                    </div>
                    <b-modal v-model="isModalVisible" :title="selectedNominee?.name" size="md" class="custom-modal"
                             id="details-modal-your-nominee" hide-footer>

                        <div class="modal-body row">
                            <!--<div class="modal-item col-md-12">
                                <font-awesome-icon icon="user" class="modal-icon"/>
                                <h5>Name: <span class="modal-value">{{ itemData.name }}</span></h5>
                            </div>-->
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="users" class="modal-icon"/>
                                <h5>{{$t("Relation")}}: <span class="modal-value">{{ selectedNominee?.relation || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="envelope" class="modal-icon"/>
                                <h5>{{$t("Email")}}: <span class="modal-value">{{ selectedNominee?.email || 'N/A' }}</span></h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="user-friends" class="modal-icon"/>
                                <h5>{{$t("Father Name")}}: <span
                                        class="modal-value">{{ selectedNominee?.fatherName || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="phone" class="modal-icon"/>
                                <h5>{{$t("Mobile")}}: <span class="modal-value">{{ selectedNominee?.mobile || 'N/A' }}</span></h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="heart" class="modal-icon"/>
                                <h5>{{$t("Marital Status")}}: <span
                                        class="modal-value">{{ selectedNominee?.maritalStatus || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="briefcase" class="modal-icon"/>
                                <h5>{{$t("Profession")}}: <span
                                        class="modal-value">{{ selectedNominee?.profession || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="calendar" class="modal-icon"/>
                                <h5>{{$t("Date")}}: <span class="modal-value">{{ selectedNominee?.wnDate || 'N/A' }}</span></h5>
                            </div>
                            <b-button variant="outline-danger" @click="nomineeRemove(selectedNominee.requestKey)" class="close-btn border-1">
                                {{$t("Remove Nominee")}}
                            </b-button>
                        </div>

                    </b-modal>
                </div>
                <div class=" add-more text-center mt-2 mb-5">
                    <router-link to="/admin/search-nominee" class="btn btn-outline-success"> [+] {{$t("Add More Nominee")}}
                    </router-link>
                </div>
            </div>

            <div class="your-nominee" v-if="nominee == 2">
                <div class="col-md-10 m-auto mt-3 nominee1 rounded" v-for="(itemData, index) in iMTheNomineeData"
                     :key="index">
                    <div class="card mb-2">
                        <div>
<!--                            <img v-if="iNomineeImageData && !iNomineeImageData.endsWith('/null')"-->
                            <img v-if="validImage(iNomineeImageData[index])"
                                 :src="iNomineeImageData[index]"
                                 class="rounded-circle border-primary me-3"
                                 height="50"
                                 width="50">
                            <img v-else
                                 src="@/assets/images/profile.jpg"
                                 class="rounded-circle border-primary me-3"
                                 height="50"
                                 width="50">
                            <span style="color: gray">{{ itemData?.name }}</span>
                        </div>
                        <div class="details text-secondary" style="cursor: pointer">
                            <font-awesome-icon icon="eye" style="margin-left: 60px; gap: 20px; "
                                               class="text-secondary"/>
                            <span @click="openModal(itemData)">{{$t("View Details")}}</span>
                        </div>
                    </div>
                    <b-modal v-model="isModalVisible" :title="selectedNominee?.name" size="md" class="custom-modal"
                             id="details-modal-im-the-nominee">

                        <div class="modal-body row">
                            <!--<div class="modal-item col-md-12">
                                <font-awesome-icon icon="user" class="modal-icon"/>
                                <h5>Name: <span class="modal-value">{{ itemData.name }}</span></h5>
                            </div>-->
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="users" class="modal-icon"/>
                                <h5>{{$t("Relation")}}: <span class="modal-value">{{ selectedNominee?.relation || 'N/A' }}</span></h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="envelope" class="modal-icon"/>
                                <h5>{{$t("Email")}}: <span class="modal-value">{{ selectedNominee?.email || 'N/A' }}</span></h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="user-friends" class="modal-icon"/>
                                <h5>{{$t("Father Name")}}: <span class="modal-value">{{ selectedNominee?.fatherName || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="phone" class="modal-icon"/>
                                <h5>{{$t("Mobile")}}: <span class="modal-value">{{ selectedNominee?.mobile || 'N/A' }}</span></h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="heart" class="modal-icon"/>
                                <h5>{{$t("Marital Status")}}: <span
                                        class="modal-value">{{ selectedNominee?.maritalStatus || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="briefcase" class="modal-icon"/>
                                <h5>{{$t("Profession")}}: <span class="modal-value">{{ selectedNominee?.profession || 'N/A' }}</span>
                                </h5>
                            </div>
                            <div class="modal-item col-md-12">
                                <font-awesome-icon icon="calendar" class="modal-icon"/>
                                <h5>{{$t("Date")}}: <span class="modal-value">{{ selectedNominee?.wnDate || 'N/A' }}</span></h5>
                            </div>
                        </div>

                        <template #modal-footer>
                            <b-button variant="outline-danger" @click="isModalVisible = false" class="close-btn">{{$t("Close")}}
                            </b-button>
                        </template>
                    </b-modal>
                </div>
                <div class=" add-more text-center mt-2 mb-5">
                    <router-link to="/admin/search-nominee" class="btn btn-outline-success"> [+] {{$t("Add More Nominee")}}
                    </router-link>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import apiRepository, {getImage} from "@/services/ApiRepository";
    import {toast} from 'vue3-toastify';

    export default {
        name: 'nomineeShow',
        data() {
            return {
                nominee: '1',
                nomineeOptions: [
                    {text: this.$t('Your Nominee'), value: '1'},
                    {text: this.$t("I'm The Nominee"), value: '2'}
                ],
                nomineeData: [],
                iMTheNomineeData: [],
                nomineeImageUrlData: null,
                iNomineeImageData: null,
                isModalVisible: false,
                selectedNominee: null,

            }
        },
        mounted() {
            this.nomineeDetails()
        },
        watch: {
            nominee(newValue) {
                if (newValue === '2') {
                    this.imTheNominee();
                }
            }
        },
        methods: {
            validImage(url) {
                return url && !url.endsWith('/null');
            },
            openModal(itemData) {
                this.selectedNominee = itemData;
                this.isModalVisible = true; // Show the modal
            },
            closeModal() {
                this.isModalVisible = false; // Hide the modal
            },
            nomineeDetails() {
                apiRepository.getNominee().then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.nomineeData = res.data;
                        this.nomineeImageUrlData = res.data.map(item => {
                            return item.imageUrl ? getImage() + item.imageUrl : null;
                        });
                        // this.nomineeImageUrlData = getImage() + res.data[0].imageUrl;
                    } else {
                        toast.error('Data no found!')
                    }
                })
            },
            imTheNominee() {
                apiRepository.getImNominee().then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.iMTheNomineeData = res.data;
                        console.log(this.iMTheNomineeData)
                        this.iNomineeImageData = res.data.map(item => {
                            return item.imageUrl ? getImage() + item.imageUrl : null;
                        });
                        // this.iNomineeImageData = getImage() + res.data[0].imageUrl;
                    }
                })
            },
            nomineeRemove(data) {
                apiRepository.nomineeUserRemove(data).then((res) => {
                    if (res) {
                        toast.success(res.data);
                        this.nomineeDetails()
                        this.closeModal()
                    }
                }).catch((error) => {
                    console.error(error.response?.data)
                })
            }
        }

    }
</script>

<style>
    .nominee1 {
        box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
        border: #077747;
    }

    /* Modal Background and Animation */
    .custom-modal .modal-content {
        background: #2d3e50; /* Dark blue background */
        border-radius: 10px; /* Rectangle shape with rounded corners */
        padding: 25px;
        color: white;
        transition: all 0.3s ease;
        animation: fadeInScale 0.5s ease-out;
    }

    /* Modal Animation */
    @keyframes fadeInScale {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    /* Flexbox Layout for Modal Content */
    .modal-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        padding: 10px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }

    .modal-item:last-child {
        border-bottom: none;
    }

    /* Text Styling */
    .modal-item h5 {
        font-size: 1.1rem;
        margin-left: 15px;
        font-weight: 600;
    }

    .modal-value {
        font-weight: 400;
        color: #f5a623; /* Bright professional yellow-orange */
    }

    /* Icons Styling */
    .modal-icon {
        font-size: 1.5rem;
        color: #f5a623; /* Bright professional yellow-orange */
    }

    /* Modal Footer */
    .modal-footer {
        padding-top: 10px;
    }

    /* Button Styling */
    .close-btn {
        background-color: #f5a623; /* Bright professional yellow-orange */
        color: #2d3e50; /* Dark blue */
        border-radius: 5px;
        font-weight: 600;
        transition: all 0.3s;
        border: none;
        padding: 10px 15px;
    }

    .close-btn:hover {
        background-color: #2d3e50; /* Dark blue */
        color: #f5a623; /* Bright professional yellow-orange */
        transform: scale(1.05);
    }

    /* Responsive Design */
    @media screen and (max-width: 768px) {
        .modal-item h5 {
            font-size: 1rem;
        }

        .modal-icon {
            font-size: 1.2rem;
        }
    }
</style>